import React, { useState, useEffect, useRef } from 'react';
import { _T, C } from '../../../shared/theme';
import { s_PB, s_GC } from '../../../shared/styles';
import { saveGameScore } from '../../../shared/utils';

const CATEGORIES = [
  {
    id: 'animals_food',
    left: { labelNL: 'Dier', labelEN: 'Animal', color: '#4AC87A', items: ['🐶','🐱','🐸','🐧','🦊','🐺','🐻','🦁','🐯','🦋'] },
    right: { labelNL: 'Eten', labelEN: 'Food', color: '#D4873A', items: ['🍎','🍕','🍔','🍟','🌮','🍰','🥑','🍇','🍜','🧁'] },
  },
  {
    id: 'nature_tech',
    left: { labelNL: 'Natuur', labelEN: 'Nature', color: '#2A9E82', items: ['🌲','🌊','🌸','🍀','🌞','🌧','🏔','🌵','🌻','🍃'] },
    right: { labelNL: 'Tech', labelEN: 'Tech', color: '#7B6FD0', items: ['💻','📱','🎮','🔋','💡','📡','🤖','⌨','🖥','🔌'] },
  },
];
const ITEMS_PER_GAME = 16;

function SpeedSortGame({ lang, onBack }) {
  const nl = lang === 'nl';
  const [phase, setPhase] = useState('start'); // start | playing | done
  const [cat] = useState(() => CATEGORIES[Math.floor(Math.random() * CATEGORIES.length)]);
  const [items, setItems] = useState([]);
  const [current, setCurrent] = useState(0);
  const [score, setScore] = useState(0);
  const [feedback, setFeedback] = useState(null); // 'correct' | 'wrong'
  const [timeLeft, setTimeLeft] = useState(30);
  const timerRef = useRef(null);

  const buildItems = () => {
    const pool = [];
    cat.left.items.forEach(e => pool.push({ emoji: e, side: 'left' }));
    cat.right.items.forEach(e => pool.push({ emoji: e, side: 'right' }));
    return pool.sort(() => Math.random() - 0.5).slice(0, ITEMS_PER_GAME);
  };

  const startGame = () => {
    const it = buildItems();
    setItems(it); setCurrent(0); setScore(0); setFeedback(null); setTimeLeft(30); setPhase('playing');
  };

  useEffect(() => {
    if (phase !== 'playing') return;
    timerRef.current = setInterval(() => {
      setTimeLeft(t => {
        if (t <= 1) { clearInterval(timerRef.current); setPhase('done'); return 0; }
        return t - 1;
      });
    }, 1000);
    return () => clearInterval(timerRef.current);
  }, [phase]);

  const answer = (side) => {
    if (phase !== 'playing' || !items[current]) return;
    const isRight = items[current].side === side;
    setFeedback(isRight ? 'correct' : 'wrong');
    if (isRight) setScore(s => s + 1);
    setTimeout(() => {
      setFeedback(null);
      const next = current + 1;
      if (next >= items.length) { clearInterval(timerRef.current); saveGameScore('speedsort', Math.round((score + (isRight ? 1 : 0)) / items.length * 100)); setPhase('done'); }
      else setCurrent(next);
    }, 150);
  };

  if (phase === 'done') {
    return (
      <div>
        <button onClick={() => onBack()} style={{ background: 'none', border: 'none', color: C.silver, cursor: 'pointer', fontSize: 13, marginBottom: 12 }}>■ {nl ? 'Stop' : 'Stop'}</button>
        <div style={{ ...s_GC({ padding: 24, textAlign: 'center' }) }}>
          <div style={{ fontSize: 52, marginBottom: 12 }}>⚡</div>
          <div style={{ color: C.white, fontSize: 20, fontWeight: 700, marginBottom: 4 }}>{nl ? 'Klaar!' : 'Done!'}</div>
          <div style={{ color: _T.accent, fontSize: 32, fontWeight: 700 }}>{score}/{ITEMS_PER_GAME}</div>
          <div style={{ color: C.silver, fontSize: 13, marginBottom: 16 }}>{nl ? 'correct gesorteerd' : 'correctly sorted'}</div>
          <button style={s_PB({ width: '100%' })} onClick={startGame}>{nl ? 'Opnieuw' : 'Play again'}</button>
        </div>
      </div>
    );
  }

  const item = items[current];

  return (
    <div>
      <button onClick={() => onBack()} style={{ background: 'none', border: 'none', color: C.silver, cursor: 'pointer', fontSize: 13, marginBottom: 12 }}>■ {nl ? 'Stop' : 'Stop'}</button>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
        <span style={{ color: C.silver, fontSize: 12 }}>{current + 1}/{items.length || ITEMS_PER_GAME}</span>
        <span style={{ color: timeLeft < 10 ? C.red : _T.accent, fontSize: 12, fontWeight: 700 }}>⏱ {timeLeft}s</span>
      </div>

      <div style={{ ...s_GC({ padding: 24, textAlign: 'center', marginBottom: 14 }), background: feedback === 'correct' ? '#4AC87A22' : feedback === 'wrong' ? '#C0505022' : _T.bg4, transition: 'background 0.1s' }}>
        {phase === 'start' && <div style={{ color: C.silver, fontSize: 13 }}>{nl ? 'Sorteer zo snel mogelijk!' : 'Sort as fast as you can!'}</div>}
        {item && <div style={{ fontSize: 64 }}>{item.emoji}</div>}
      </div>

      {phase === 'start' && <button style={s_PB({ width: '100%' })} onClick={startGame}>{nl ? 'Start' : 'Start'}</button>}
      {phase === 'playing' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <button onClick={() => answer('left')} style={{ height: 72, borderRadius: 16, border: 'none', cursor: 'pointer', background: `${cat.left.color}22`, color: cat.left.color, fontSize: 15, fontWeight: 700 }}>
            ← {nl ? cat.left.labelNL : cat.left.labelEN}
          </button>
          <button onClick={() => answer('right')} style={{ height: 72, borderRadius: 16, border: 'none', cursor: 'pointer', background: `${cat.right.color}22`, color: cat.right.color, fontSize: 15, fontWeight: 700 }}>
            {nl ? cat.right.labelNL : cat.right.labelEN} →
          </button>
        </div>
      )}
    </div>
  );
}

export default SpeedSortGame;
